export default [
  {
    path: '/enquiry/list',
    name: 'enquiryList',
    component: () => import('@/views/enquiry/index'),
    meta: {
      keepAlive: false,
      bg_white: true
    }
  },
  {
    path: '/enquiry/detail',
    name: 'enquiryDetail',
    component: () => import('@/views/enquiry/detail'),
    meta: {
      keepAlive: false
    }
  },
]
